// src/components/dashboard/ScenarioInvestmentComparison.js
import React from "react";
import { useAnnCostInvestmentSummary } from "../../hooks/useAnnCostInvestmentSummary";

export default function ScenarioInvestmentComparison({
  scenario,
  baselineYear = 2025,
  targetYear = 2050,
  from = 2025,
  to = 2050,
  sectors = ["ELC", "IND", "TRA", "RES","OTH"],
  households = 28_000_000,
  pvToGBP = 1e6, // set to 1e6 if ANN-COST values are £ millions
}) {
  const { investmentDetails, loading, error } = useAnnCostInvestmentSummary({
    scenario, sectors, baselineYear, targetYear, from, to, households, pvToGBP,
  });

  if (loading) return <div className="mt-6 bg-gray-50 p-4 rounded-lg border w-full sm:w-3/5 lg:w-2/5 mx-auto text-xs">Loading investment summary…</div>;
  if (error) return <div className="mt-6 bg-red-50 p-4 rounded-lg border border-red-200 w-full sm:w-3/5 lg:w-2/5 mx-auto text-xs text-red-700">Error: {error.message}</div>;

  if (!investmentDetails) return null;

  const pct = investmentDetails.investmentIncrease;
  const pctClass = pct >= 0 ? "text-green-600" : "text-red-600";
  const pctWord  = pct >= 0 ? "increase" : "decrease";

  return (
    <div className="mt-6 bg-gray-50 p-4 rounded-lg border w-full sm:w-3/5 lg:w-2/5 mx-auto">
  <h4 className="text-sm font-medium text-gray-700 mb-3">Scenario Investment Comparison</h4>

  <dl className="grid grid-cols-[1fr_auto] gap-x-4 gap-y-2">
    <dt className="text-xs text-gray-600">
      Total investment needed across public, private and household sectors in 2050 in this scenario
    </dt>
    <dd className="text-lg font-bold text-blue-600 text-right whitespace-nowrap tabular-nums self-start">
      £{investmentDetails.totalInvestmentPV} billion
    </dd>

    <dt className="text-xs text-gray-600">
      Change in total investments over time compared to 2025:
    </dt>
    <dd className={`text-lg font-bold text-right whitespace-nowrap tabular-nums self-start ${pctClass}`}>
      {Math.abs(pct).toFixed(1)}% {pctWord}
    </dd>
  </dl>

  <p className="text-xs text-gray-500 mt-3 italic">
    The amount of investment needed varies between scenarios, reflecting the different extent and types of new
    infrastructure required. This investment may come in part from government, the private sector, and households.
  </p>
</div>

  );
}
